<template>
  <v-container class="step">
    <v-row justify="center" class="full-height">
      <v-col class="s18-container">
          <div xs="6" sm="6" md="7" class="s18-left"
              data-aos="fade-right"
              data-aos-delay="0"
              data-aos-duration="2000"
              data-aos-mirror="true"
              data-aos-once="false"
            >
              <div class="s18-txt">
                <p class="s18-txt-1">
                  {{$t("_s18_txt_1")}}
                </p>
                <p>
                  {{$t("_s18_txt_2")}}
                </p>
                <p>
                  {{$t("_s18_txt_3")}}
                </p>
              </div>
            </div>
            <div xs="6" sm="6" md="5" class="s18-right">
              <div class="image-container"
                data-aos="fade-left"
                data-aos-delay="0"
                data-aos-duration="2000"
                data-aos-mirror="true"
                data-aos-once="false"
              >
                <img
                  alt="renb renb.jp 生プラセンタ 化粧品"
                  class="s18-img"
                  contain
                  :src="baseUrl + '/media/image/renb_pic13.png'" />
              </div>
          </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  data () {
    return {
      baseUrl: process.env.VUE_APP_BASE_URL
    }
  }
}
</script>

<style scoped>
.s18-container {
    width: 100%; /* Chiều rộng của div */
    height: 100%; /* Hoặc có thể là một giá trị cụ thể như 500px */
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
}
.s18-left {
  width: 60%;
  max-height: 80%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.s18-right {
  width: 40%;
  max-height: 80%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.s18-img {
  /* max-height: 500px; */
  object-fit: contain;
  position: relative;
}
.s18-txt {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 500px;
  width: 550px;
  line-height: 2;
  white-space: pre-line;
}
.s18-txt-1 {
  padding-bottom: 10%;
  font-family: "ZenkakuBlack";
  font-weight: 500;
}
.image-container {
  width: 100%;
  height: 100%;
}
@media (max-width: 960px) {
  .s18-container {
      align-items: start;
  }
  .step {
    height: unset!important;
    scroll-snap-align:unset;
    margin-top: 20%;
  }
  .full-height {
    height: unset!important;
    width: 100%;
  }
  .s18-right {
    width: 50%;
  }
  .s18-left {
    width: 49%;
    position: relative;
    display: block;
    position: relative;
    top: 0;
    padding: 0 20px;
  }
  .s18-img {
    /* max-height: 500px; */
    width: 100%;
  }
  .s18-txt {
    height: 100%;
    width: 100%;
    line-height: 2;
    height: 500px;
  }
}
@media (max-width: 600px) {
  .s18-right {
    width: 100%;
  }
  .s18-left {
    width: 100%;
  }
  .s18-container {
    flex-direction: column-reverse;
    padding: unset!important;
  }
  .s18-left {
    padding: 0 10px;
  }
}
</style>